// Ворота защищённой области. Нет сессии — на вход; сессия поднимается — честное ожидание,
// а не мигание между экраном входа и разделом.

import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuthStore } from './store';

export function RequireAuth() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === 'anonymous') {
    // Откуда пришли, запоминается: после входа человек вернётся на тот же адрес,
    // а не на стартовый экран.
    return <Navigate to='/login' replace state={{ from: location }} />;
  }

  if (status === 'restoring') {
    return (
      <div className='flex h-full min-h-full items-center justify-center bg-bg-white-0'>
        <p className='text-paragraph-sm text-text-sub-600'>Открываем прошлую сессию…</p>
      </div>
    );
  }

  return <Outlet />;
}
